<template>

    <m-edit1/>

    <m-single-brand-301 v-bind='{...{"brandLink":null},...{}}' :style='""' class="brand-description mt-4" ></m-single-brand-301>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleBrand301 from '@moeinmdn/miw-alpha-components/src/package/Brand/Single/SingleBrand301';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleBrand301 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
